import React from 'react';
import { metersToFeet } from '../../lib/units';
import { LegendCard } from './LegendCard';

// matplotlib viridis sampled at 5 stops. Earthscale renders with its own
// viridis implementation server-side, so this CSS gradient is visually
// representative rather than pixel-matched.
const VIRIDIS_CSS_GRADIENT =
  'linear-gradient(to right, #440154 0%, #3b528b 25%, #21918c 50%, #5ec962 75%, #fde725 100%)';

interface CanopyHeightMapLegendProps {
  // Raw Earthscale rescale bounds in meters (the colormap is applied server-side
  // in meters). Labels are converted to feet for display per project convention.
  rescale: [number, number];
}

export const CanopyHeightMapLegend: React.FC<CanopyHeightMapLegendProps> = ({ rescale }) => {
  const [vmin, vmax] = rescale;
  return (
    <LegendCard title="Canopy height" positioned className="w-[220px]">
      <div
        className="h-3 w-full rounded-sm"
        style={{ background: VIRIDIS_CSS_GRADIENT }}
      />
      <div className="flex items-center justify-between text-[10px] font-roboto-mono text-neutral-400 mt-1">
        <span>{Math.round(metersToFeet(vmin))} ft</span>
        <span>{Math.round(metersToFeet(vmax))} ft</span>
      </div>
    </LegendCard>
  );
};
